<template>
  <div class="cart-empty-text text-center">
    <p>
      {{ strings.empty }}
    </p>
    <button
      class="btn btn--black"
      data-close
      @click="closeSlideoutCart($event)"
    >
      {{ strings.continue }}
    </button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      strings: { ...window.theme.cart.strings }
    }
  }
}
</script>
